import { isSubscriptionLink } from './links'

export const isFullHref = (url: string): boolean =>
  /^(f|ht|Ht)tps?:\/\//.test(url)
export const isPdf = (url: string): boolean => String(url).endsWith('.pdf')
export const isExternal = (url: string): boolean =>
  isFullHref(url) || isSubscriptionLink(url) || isPdf(url)
